import React, { createContext, useContext } from 'react';
export const SubStepsContext = createContext([]);
export const SubSteps = props => {
  const _props$start = props.start,
        start = _props$start === void 0 ? 0 : _props$start,
        _props$unwrap = props.unwrap,
        unwrap = _props$unwrap === void 0 ? false : _props$unwrap;
  const parent = useContext(SubStepsContext);

  if (unwrap) {
    return React.createElement(React.Fragment, null, props.children);
  }

  return React.createElement(SubStepsContext.Provider, {
    value: [...parent, start]
  }, props.children);
};